export default {
  errors: {
    title: 'Помилка',
    common: 'Щось пішло не так',
    unauthorized: 'Пароль або телефон не дійсні',
    emptyFields: 'Необхідно заповнити всі поля',
    emptyTranslationFields: 'Необхідно заповнити всі мови',
  },
};
